import { render, staticRenderFns } from "./BaseLeftIcon.vue?vue&type=template&id=6ab1b79a"
import script from "./BaseLeftIcon.vue?vue&type=script&lang=js"
export * from "./BaseLeftIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports